import { TrackingService } from './TrackingService';

import type { Field } from '$lib/types/Field';
import type { LayoutPageEntry } from '$lib/types/LayoutData';
import type { TrackingServiceConfig } from './TrackingService';

let instance: TrackingService | null = null;

export const createTrackingService = (
    config: TrackingServiceConfig,
    pages: LayoutPageEntry[],
    fields?: Field[],
): void => {
    instance = new TrackingService(config, pages);
    instance.bootstrap(fields);
};

export const getTrackingService = (): TrackingService => {
    if (!instance)
        throw new Error(
            'TrackingService not initialized — createTrackingService must be called first',
        );
    return instance;
};
